export default __webpack_public_path__ + "static/media/get_sauced.d726a583.png";